<template>
    <v-form @submit.prevent="saveTemplate" ref="form">
        <v-card class="rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">Save Access Control as Template</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{errorMessage}}
            </v-alert>
            <v-card-text>
                <v-layout row wrap> 
                    <v-flex xs12 sm12 style="padding:5px 15px 0px 15px; ">
                        <v-text-field
                            v-model="templateName"
                            label="New template name"
                            :rules="[rules.required]"
                            type="text"
                            :disabled="disabled"
                            maxlength="50"
                            style="margin-top:-15px"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="m-15">
                         <v-card lass="rounded-4">
                            <v-toolbar flat height="45px">
                                <b>Existing templates</b>
                            </v-toolbar>
                            <v-data-table
                                :headers="header"
                                :items="templates"
                                :hide-actions="templates.length<4"
                                :rows-per-page-items="[3]"
                            >
                                <template v-slot:items="props">
                                    <tr>
                                        <td>{{props.item.templateName}}</td>
                                        <td>{{props.item.createdByName}}</td>
                                        <td>{{props.item.createdOn | moment('MMM DD, YYYY')}}</td>
                                    </tr>
                                </template>
                            </v-data-table>    
                         </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions height="45px">
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :loading="loading" dark class="mr-20">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import appsApi from '@/api/applications'

export default {
    data () {
        return {
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            rules: {
                required: value => !!value || "Required.",
                max: value => value.length <= 50 || "Max 50 characters"
            },
            header: [
                {text: 'Template name',align: 'left',value: '',width: '40%', sortable:false},
                {text: 'Created By',align: 'left',value: '',width: '40%', sortable:false},
                {text: 'Created On',align: 'left',value: '',width: '20%', sortable:false},
            ],
            templates: [],
            templateName: null,
            userId: null
        }   
    },
    methods: {
        async loadTemplates(userId) {
            try{
                this.userId = userId
                await this.getTemplates()
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
           
        },
        async getTemplates() {
            try{
                this.loading = true
                const response = await appsApi.getTemplates()
                if (response && response.status==200) {
                    this.templates = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async saveTemplate() {
            try {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    var data = {
                        userId: this.userId,
                        templateName: this.templateName
                    }
                    const response = await appsApi.saveTemplate(data)
                    if (response && response.status==200) {
                        this.$refs.form.reset()
                        await this.getTemplates()
                    }
                    this.loading = false
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialog_saveas', false)
        },
    },
    created() {},
    computed: {}
}
</script>